import axios from 'axios';


const getDailyMembershipStats = async(formdetails,page,records) =>{
   
    const formdata = {
        filters : formdetails,
        page : page,
        records : records
    }
    console.log("Form data in service",formdata);
    const response = await axios.post('/api/daily-membership-stats/get-daily-membership-stats',formdata);
    return response.data;
}


export default {
    getDailyMembershipStats,
   
}